import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Spinner } from 'shared';
import { clearPersonalInfo } from '../actions';
import PrequalAcceptDeclineModal from '../components/PrequalAcceptDeclineModal';
import PrequalDeclineModal from '../components/PrequalDeclineModal';
function CoveredIframePage() {
    const location = useLocation();
    const { lenderNextStepUrl, modalType } = location.state;
    const [loading, setLoading] = useState(true);
    const [modalShown, setModalShown] = useState(modalType !== 'no-modal');
    const dispatch = useDispatch();
    useEffect(() => {
        return () => {
            dispatch(clearPersonalInfo());
        };
    }, []);
    return (_jsxs("div", { className: "access-loans", children: [loading && _jsx(Spinner, {}), _jsx("iframe", { title: "Access Loans", className: "access-loans--iframe", onLoad: () => {
                    setLoading(false);
                }, src: lenderNextStepUrl }), modalShown && modalType == 'prequal' && (_jsx(PrequalDeclineModal, { onContinue: () => setModalShown(false) })), modalShown && modalType == 'credit' && (_jsx(PrequalAcceptDeclineModal, { onClose: () => setModalShown(false) }))] }));
}
export default CoveredIframePage;
